"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useTimeout(callback, delay) {
    const savedCallback = react_1.useRef(callback);
    // Remember the latest callback if it changes.
    react_1.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the timeout.
    react_1.useEffect(() => {
        // Don't schedule if no delay is specified.
        if (delay === null) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
exports.useTimeout = useTimeout;
function useInterval(callback, delay) {
    const savedCallback = react_1.useRef(callback);
    // Remember the latest callback if it changes.
    react_1.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    react_1.useEffect(() => {
        // Don't schedule if no delay is specified.
        if (delay === null) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
exports.useInterval = useInterval;
